<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd" :disabled="!canWrite"
          >新增</el-button
        >
        <el-button type="primary" style="margin-left: 4px" @click="save" :disabled="Status === 2 || !canWrite"
          >保存</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          :disabled="btnDisabled || Status === 2 || !canWrite"
          @click="open"
          >提取</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          :disabled="!isSave || Status === 2 || !canWrite"
          @click="handleDelete"
          >删除</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="reView"
          v-if="Status !== 2"
          :disabled="!isSave || !canReview"
          >审核</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="cancelReView"
          v-if="Status === 2"
          :disabled="!isSave || !canReview"
          >弃审</el-button
        >
      </div>
      <el-form
        :model="data"
        ref="form"
        :inline="true"
        :line-form="true"
        label-width="100px"
        status-icon
      >
        <el-row style="margin-top: 18px">
          <el-form-item label="账面日期" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.DocDate }}</span>
            <el-date-picker
              v-else
              v-model="data.DocDate"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 180px"
              @change="(v) => getPreviewNo(v)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="单据编码" required label-width="100px">
            <span
              style="display: inline-block; width: 180px"
              v-if="Mode == 0"
              class="detail-span"
              >{{ data.DocNo }}</span
            >
            <el-input
              style="width: 180px"
              v-else
              v-model="data.DocNo"
              placeholder="请输入单据编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="出库类别" required>
            <type-outselect ref="typeOutSelect" :disabledStatus="Status" v-model="data.OutClassId" />
          </el-form-item>
          <el-form-item label="入库类别" required>
            <type-inselect ref="typeInSelect" :disabledStatus="Status" v-model="data.InClassId" />
          </el-form-item>
          <el-form-item label="仓库" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{
              data.WarehouseName
            }}</span>
            <el-select v-else style="width: 180px" v-model="data.WarehouseId">
              <el-option
                v-for="item in warehouseList"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经手人" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.EmpName }}</span>
            <select-input
              v-else
              placeholder="请选择经办人"
              :label="data.EmpName"
              v-model="data.EmpId"
              @click="openEmp"
              style="width: 180px"
            />
          </el-form-item>
          <el-form-item label="制单人" label-width="100px">
            <span class="span" style="width: 180px !important">{{
              data.MarkEmpName
            }}</span>
          </el-form-item>
        </el-row>
      </el-form>

      <el-table
        border
        class="table_bottom table-line tb-c-head"
        :data="tableData"
        :row-class-name="tableRowClassName"
        stripe
        style="margin-top: 18px"
        @row-click="add"
        v-keymove="newLine"
      >
        <insert-row @on-insert="onInsert" />
        <!-- <el-table-column
          label="条形码"
          prop="ProductNo"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <vue-barcode
              v-if="row.ProductNo"
              :value="row.ProductNo"
              height="20"
              fontSize="10"
            ></vue-barcode>
          </template>
        </el-table-column> -->
        <el-table-column
          label="存货名称"
          prop="ProductName"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2 || !data.WarehouseId">{{
              row.ProductName
            }}</span>
            <account-select
              v-else
              v-model="row.ProductName"
              :source="DAccount"
              @select="onSelect($event, row)"
              :pageSize="pageParams.pageSize"
              :pageIndex="pageParams.pageIndex"
              :listTotal="listTotal"
              @inputText="inputText"
              @click.native="resetFun"
              @currentPage="currentPage"
              :pageType="true"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="存货编码"
          prop="ProductNo"
          align="center"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          label="规格型号"
          prop="ProductSpec"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="颜色"
          prop="ColorId"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <el-select
              v-if="row.UseColor && Status !== 2"
              v-model="row.ColorId"
              @change="changeColor($event, row)"
            >
              <el-option
                v-for="item in row.Colors"
                :key="item.ColorId"
                :label="item.ColorName"
                :value="item.ColorId"
              ></el-option>
            </el-select>
            <span
              class="not-edit"
              v-else
              >{{ row.UseColor ? row.ColorName : ""}}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="计量单位"
          prop="UnitName"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="账面数量"
          prop="Quantity"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="盘点数量"
          prop="InventoryQuantity"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{
              row.InventoryQuantity
            }}</span>
            <el-input
              type="text"
              v-else
              v-model="row.InventoryQuantity"
              @change="changeInventoryQuantity($event, row)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="盈亏数量"
          prop="DiffQuantity"
          align="center"
          min-width="100"
        >
        </el-table-column>

        <el-table-column label="单价" prop="Price" align="center" min-width="100">
        </el-table-column>
        <el-table-column
          label="账面金额"
          prop="Amount"
          align="center"
          min-width="100"
        >
        
        </el-table-column>
        <el-table-column
          label="盘点金额"
          prop="CheckAmount"
          align="center"
          min-width="100"
        >
        </el-table-column>

        <el-table-column
          label="盈亏金额"
          prop="ProfitLossAmount"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="计量单位2"
          prop="UnitId2"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <el-select
              :disabled="Status === 2"
              v-model="row.UnitId2"
              @change="changeUnitId2($event, row)"
              v-if="row.Units2 && row.Units2.length !== 0"
            >
              <el-option
                v-for="item in row.Units2"
                :key="item.UnitId"
                :label="item.UnitName"
                :value="item.UnitId"
              ></el-option>
            </el-select>
            <span v-else>{{ row.UnitName2 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账面数量2"
          prop="Quantity2"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="盘点数量2"
          prop="InventoryQuantity2"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="盈亏数量2"
          prop="DiffQuantity2"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="换算率"
          prop="Rate"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <span>{{
              row.Rate
                ? parseFloat(row.Rate).toFixed(optionData.Iinvexchrate)
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row, $index }">
            <el-button
              type="text"
              @click="del(row, $index)"
              :disabled="Status === 2"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="mtx10">
        <div class="flex">
          <div class="text el-form-item__label">备注</div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            v-model="data.Remark"
            :disabled="Status === 2"
          ></el-input>
        </div>
      </div>

      <div class="mtx10">
        <div class="flex space-between">
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核人</div>
            <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核时间</div>
            <div class="center el-form-item__label">{{ data.ReviewTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <edit-dialog ref="editDialog" @saved="saved"></edit-dialog>
  </div>
</template>
<script>
import VueBarcode from "vue-barcode";
import editDialog from "@/components/business/stock/inventoryoverflow/editDialog";
import accountSelect from "@/components/business/stock/select";
import empDialog from "@/components/personnel/result/record/listDialog";
import optionMixins from "@/mixins/option";
import typeOutselect from "./outSelect";
import typeInselect from "./inSelect";

export default {
  mixins: [optionMixins],
  name: "editinventoryoverflow",
  components: {
    editDialog,
    accountSelect,
    VueBarcode,
    empDialog,
    typeOutselect,
    typeInselect,
  },
  data() {
    return {
      pdApi: require("@/api/ba/product").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      code_api: require("@/api/sy/serialCode").default,
      sourceTypeApi:require("@/api/ba/sourceType").default,
      api: require("@/api/stock/stSpillLossDoc").default,
      propertyApi: require("@/api/ba/property").default,
      propertyList: [],
      Mode: 0,
      warehouseList: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      Status: 0,
      isSave: false,
      data: {
        OutClassId: 0,
        InClassId: 0,
        DocId: 0,
        DocType: 0,
        DocDate: this.$commonJs.getToday(),
        DocNo: "",
        WorkShopId: 0,
        WorkShopName: "",
        WarehouseId: null,
        EmpName: "",
        EmpId: 0,
        MarkEmpName: "",
        MakeEmpId: 0,
        ReviewEmpName: "",
        ReviewEmpId: 0,
        ReviewTime: "",
        Remark: "",
      },
      date: [],
      tableData: [
        {
          T: 0,
          DocId: 0,
          DocProductId: 0,
          ProductId: "",
          ProductName: "",
          ProductNo: "",
          ProductSpec: "",
          ColorId: null,
          ColorName: "",
          Colors: [],
          Quantity: 0,
          InventoryQuantity: 0,
          DiffQuantity: 0,
          Price: 0,
          Amount: 0,
          CheckAmount: 0,
          ProfitLossAmount: 0,
          Quantity2: 0,
          InventoryQuantity2: 0,
          DiffQuantity2: 0,
          Rate: "",
          UnitName: "",
          UnitName2: "",
          UnitId: "",
          UnitId2: "",
          Units: [],
        },
      ],
      viewType: "create",
      delTableData: [],
    };
  },
  computed: {
    btnDisabled() {
      return this.data.WarehouseId == null ? true : false;
    },
  },
  created() {
    this.init();
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/stock/inventoryoverflow");
    },
    canWrite() {
      return this.$permission.canWrite("/business/stock/inventoryoverflow");
    },
    canReview() {
      return this.$permission.canReview("/business/stock/inventoryoverflow");
    },
  },
  mounted() {
    this.viewType = this.$route.params.type;
    this.$refs.typeOutSelect.init();
    this.$refs.typeInSelect.init();
    if (this.$route.params.type === "create") {
      this.getPreviewNo();
      const user = this.$store.state.user;
      if (user) {
        this.data.EmpId = user.empId;
        this.data.EmpName = user.name;
      }
    } else if (this.$route.params.type === "edit") {
      this.editInit(this.$route.params.data);
      this.data.WarehouseName=this.$route.params.data.WarehouseName
      this.data.WarehouseId=this.$route.params.data.WarehouseId
    } 
   
  },

  methods: {
    onInsert(e){
      let {type, index} = e;

      this.interpolate(null, index, type)
      
    },
    interpolate(row, index,type=""){
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        ProductId: "",
        ProductName: "",
        ProductNo: "",
        ProductSpec: "",
        ColorId: null,
        ColorName: "",
        Colors: [],
        Quantity: 0,
        InventoryQuantity: 0,
        DiffQuantity: 0,
        Price: 0,
        Amount: 0,
        CheckAmount: 0,
        ProfitLossAmount: 0,
        Quantity2: 0,
        InventoryQuantity2: 0,
        DiffQuantity2: 0,
        Rate: "",
        UnitName: "",
        UnitName2: "",
        UnitId: "",
        UnitId2: "",
        Units: [],
      };
      if(type=="down"){
        index=index+1;
      }
      this.tableData.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableData));
      this.tableData = [];
      this.$nextTick(() => {
        this.tableData = copy;
      })
      console.log("this.tableData",this.tableData)
 
    },
    setEmp(data) {
      console.log(data);
      this.data.EmpId = data.EmpId;
      this.data.EmpName = data.EmpName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("溢损单", dateTime).then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取溢损单编号失败");
        }
      });
    },
    init() {
      this.propertyApi
        .list({
          Status: 1,
        })
        .then((res) => {
          if (res.Code === 0) {
            this.propertyList = res.Data;
          }
        });

      this.pdApi
        .list({
          Status: 1,
          PageIndex: this.pageParams.pageIndex,
          pageSize: this.pageParams.pageSize,
        })
        .then((res) => {
          this.DAccount = res.Data;
          this.initDAccount = res.Data;
          this.listTotal = res.Count;
          this.initTotal = res.Count;
          // var place = [].concat[this.tableData];
          // this.tableData = [];
          this.tableData.forEach((item) => {
            var obj = this.DAccount.find(x => item.ProductId == x.ProductId);
            if(obj) item.Colors = obj.Colors;
          });
          // this.tableData = place;
        });

      this.warehouseApi.list({ Status: 1, WarehouseType: 2 }).then((res) => {
        if (res.Code === 0) {
          this.warehouseList = res.Data.map((item) => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId,
            };
          });
        }
      });

      this.sourceTypeApi.list({}).then(res=>{
       if(res.Code==0){
        this.SourceTypeIdArr=res.Data
        let params="库存溢损单"
        let index=  this.SourceTypeIdArr.findIndex(item=>item.SourceType==params)
        let SourceTypeId =this.SourceTypeIdArr[index].SourceTypeId
        this.data.DocType=SourceTypeId
      }
      })

      this.callOptionApi();
    },
    editInit(data) {
      this.viewType = "edit";
      this.isSave = true;
      let {
        Products,
        OutClassId,
        InClassId,
        DocId,
        DocType,
        DocDate,
        DocNo,
        WorkShopId,
        WorkShopName,
        WarehouseId,
        EmpName,
        EmpId,
        Status,
        MarkEmpName,
        MakeEmpId,
        ReviewEmpName,
        ReviewEmpId,
        ReviewTime,
        Remark,
      } = data;

      this.data = {
        OutClassId,
        InClassId,
        DocId,
        DocType,
        DocDate,
        DocNo,
        WorkShopId,
        WorkShopName,
        WarehouseId,
        EmpName,
        EmpId,
        MarkEmpName,
        MakeEmpId,
        ReviewEmpName,
        ReviewEmpId,
        ReviewTime,
        Remark,
      };

      this.Status = Status;

      Products.forEach((item) => {
        item.InventoryQuantity2 = 0;
        item.DiffQuantity2 = 0;
        item.ChangeType = 0;
      });

      Products.forEach((item) => {
        this.changeInventoryQuantity(item.InventoryQuantity ,item);
        item.T = null;
      });

      this.tableData = Products;
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    changeUnitId2(val, row) {
      this.editT(row);

      let item = row.Units2.filter((item) => {
        return item.UnitId === val;
      })[0];

      row.UnitId2 = item.UnitId;
      row.UnitName2 = item.UnitName;

      row.Rate2 = item.Rate;
      row.ChangeType2 = item.ChangeType;

      row.Rate = row.Rate1 / row.Rate2;
    },
    changeInventoryQuantity(val, row) {
      if (!row.Rate) {
        this.$message({ type: "warning", message: "请先选择计量单位2" });
        row.InventoryQuantity = 0;
        return;
      }

      this.editT(row);

      val = this.setNumber(val)
      row.InventoryQuantity = parseFloat(this.getQuantity(val));

      //盈亏数量
      row.DiffQuantity = parseFloat(
        this.getQuantity(row.InventoryQuantity - row.Quantity)
      );

      // 盘点金额
      row.CheckAmount = parseFloat((row.InventoryQuantity * row.Price).toFixed(2));

      // 盈亏金额
      row.ProfitLossAmount = parseFloat(
        (row.DiffQuantity * row.Price).toFixed(2)
      );

      if (row.UnitId2) {
        if (row.ChangeType === 1) {
          if (row.Quantity2 <= 0) {
            row.Quantity2 = this.getQuantity(row.Quantity / row.Rate);
          }

          if (row.InventoryQuantity2 <= 0) {
            row.InventoryQuantity2 = this.getQuantity(row.InventoryQuantity / row.Rate);
          }

          if (row.DiffQuantity2 <= 0) {
            row.DiffQuantity2 = this.getQuantity(
              row.DiffQuantity / row.Rate
            );
          }
        } else if (row.ChangeType === 1 && row.Quantity2 > 0) {
          if (row.Quantity2 > 0) {
            row.Rate = this.getIinvexchrate(row.Quantity / row.Quantity2);
          }

          if (row.InventoryQuantity2 > 0) {
            row.Rate = this.getIinvexchrate(
              row.InventoryQuantity / row.InventoryQuantity2
            );
          }

          if (row.DiffQuantity2 > 0) {
            row.Rate = this.getIinvexchrate(
              row.DiffQuantity / row.DiffQuantity2
            );
          }
        } else if (row.ChangeType === 0) {
          row.Quantity2 = this.getQuantity(row.Quantity / row.Rate);
          row.InventoryQuantity2 = this.getQuantity(row.InventoryQuantity / row.Rate);
          row.DiffQuantity2 = this.getQuantity(
            row.DiffQuantity / row.Rate
          );
        }
      }
    },
    onSelect(e, row) {
      if(!this.data.WarehouseId) {
        this.$message({type: 'warning', message: '请先选择仓库'})
        return
      }

      this.editT(row);

      row.Units = [];

      row.UnitName = "";

      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.UseColor = e.UseColor;
      row.Colors = e.Colors;
      row.Units = e.Units;

      if(e.Units.length !== 0){
          let Units = e.Units.filter((item) => {
          return item.IsMain;
        });
        if (Units.length !== 0) {
          row.ChangeType = Units[0].ChangeType;
          row.Rate1 = Units[0].Rate;
          row.UnitId = Units[0].UnitId;
          row.UnitName = Units[0].UnitName;
        }

        row.Units2 = e.Units.filter((item) => {
          return !item.IsMain;
        });

        if(row.Units2.length !== 0){
          row.UnitId2 = row.Units2[0].UnitId;
          row.UnitName2 = row.Units2[0].UnitName;

          row.Rate2 = row.Units2[0].Rate;
          row.ChangeType2 = row.Units2[0].ChangeType;
          row.Rate = row.Rate1 / row.Rate2;
        }

        if(e.Units.length === 0){
          row.UnitId = e.SkUnitId;
          row.UnitName = e.SkUnitName;
        }
      }else{
        row.UnitId = e.SkUnitId;
        row.UnitName = e.SkUnitName;
        row.UnitId2 = e.SkUnitId;
        row.UnitName2 = e.SkUnitName;
        row.ChangeType = 0
        row.ChangeType2 = 0
        row.Rate = 1
      }

      this.api.referenceCost({WarehouseId: this.data.WarehouseId, ProductId: row.ProductId}).then(res => {
        if(res.Code === 0){
          row.Price = res.Data.ReferenceCost;
          row.Quantity = res.Data.ExistQuantity;
          row.Amount = parseFloat((row.Quantity * row.Price).toFixed(2))
        }
      })


    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage(val) {
      this.pageParams.pageIndex = val;
      this.pdApi.list({ pageIndex: val, pageSize: 7 }).then((res) => {
        if (res.Code == 0) {
          this.DAccount = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
    inputText(text) {
      this.pdApi
        .list({ pageIndex: 1, pageSize: 7, ProductName: text })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    open() {
      this.$refs.editDialog.open().then((that) => {
        that.init();
      });
    },
    saved(data) {
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        ProductId: "",
        ProductName: "",
        ProductNo: "",
        ProductSpec: "",
        Quantity: 0,
        InventoryQuantity: 0,
        DiffQuantity: 0,
        Price: 0,
        Amount: 0,
        CheckAmount: 0,
        ProfitLossAmount: 0,
        Quantity2: 0,
        InventoryQuantity2: 0,
        DiffQuantity2: 0,
        Rate: "",
        UnitName: "",
        UnitName2: "",
        UnitId: "",
        UnitId2: "",
        Units: [],
      };

      o.ProductName = data.ProductName;
      o.ProductNo = data.ProductNo;
      o.ProductId = data.ProductId;
      o.ProductSpec = data.ProductSpec;
      o.Units = data.Units;

      if(data.Units.length !== 0){

        let Units = data.Units.filter((item) => {
          return item.IsMain;
        });
        if (Units.length !== 0) {
          o.ChangeType = Units[0].ChangeType;
          o.Rate1 = Units[0].Rate;
          o.UnitId = Units[0].UnitId;
          o.UnitName = Units[0].UnitName;
        }

        o.Units2 = data.Units.filter((item) => {
          return !item.IsMain;
        });

        if(o.Units2.length !== 0){
          o.UnitId2 = o.Units2[0].UnitId;
          o.UnitName2 = o.Units2[0].UnitName;

          o.Rate2 = o.Units2[0].Rate;
          o.ChangeType2 = o.Units2[0].ChangeType;
          o.Rate = o.Rate1 / o.Rate2;
      }

      }else{
        o.UnitId = data.SkUnitId;
        o.UnitName = data.SkUnitName;
        o.UnitId2 = data.SkUnitId;
        o.UnitName2 = data.SkUnitName;
        o.ChangeType = 0
        o.ChangeType2 = 0
        o.Rate = 1
      }

      this.api.referenceCost({WarehouseId: this.data.WarehouseId, ProductId: o.ProductId}).then(res => {
        if(res.Code === 0){
          o.Price = res.Data.ReferenceCost;
          o.Quantity = res.Data.ExistQuantity;
        }
      })

      this.tableData.push(o);
    },
    del(row, index) {
      this.$confirm("确认删除这条数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (row.T !== 0) {
          row.T = 2;
          this.delTableData(row);
        }

        this.tableData.splice(index, 1);
        if (this.tableData.length === 0) {
          this.newLine();
        }
      });
    },
    changeColor(val, row) {
      this.editT(row);

      let item = row.Colors.filter((item) => {
        return item.ColorId === val;
      })[0];

      row.ColorName = item.ColorName;
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    newLine() {
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        ProductId: "",
        ProductName: "",
        ProductNo: "",
        ProductSpec: "",
        ColorId: null,
        ColorName: "",
        Colors: [],
        Quantity: 0,
        InventoryQuantity: 0,
        DiffQuantity: 0,
        Price: 0,
        Amount: 0,
        CheckAmount: 0,
        ProfitLossAmount: 0,
        Quantity2: 0,
        InventoryQuantity2: 0,
        DiffQuantity2: 0,
        Rate: "",
        UnitName: "",
        UnitName2: "",
        UnitId: "",
        UnitId2: "",
        Units: [],
      };

      this.tableData.push(o);
    },
    add(row, column) {
      if (column.label === "操作" || this.Status === 2) {
        return;
      }
      if (row.index === this.tableData.length - 1) {
        this.newLine();
      }
    },
    getProducts(data) {

      data = data.filter((item) => {
        return item.ProductName;
      });

      let Products = [];
      data.forEach((item) => {
        let {
          T,
          DocId,
          DocProductId,
          ProductId,
          ProductName,
          ProductNo,
          ProductSpec,
          ColorId,
          ColorName,
          Colors,
          Quantity,
          InventoryQuantity,
          DiffQuantity,
          Price,
          Amount,
          CheckAmount,
          ProfitLossAmount,
          Quantity2,
          InventoryQuantity2,
          DiffQuantity2,
          Rate,
          UnitName,
          UnitName2,
          UnitId,
          UnitId2,
          Units,
        } = item;

        let o = {
          T,
          DocId,
          DocProductId,
          ProductId,
          ProductName,
          ProductNo,
          ProductSpec,
          ColorId,
          ColorName,
          Colors,
          Quantity,
          InventoryQuantity,
          DiffQuantity,
          Price,
          Amount,
          CheckAmount,
          ProfitLossAmount,
          Quantity2,
          InventoryQuantity2,
          DiffQuantity2,
          Rate,
          UnitName,
          UnitName2,
          UnitId,
          UnitId2,
          Units,
        };

        Products.push(o);
      });

      return Products;
    },
    save() {

      //验证表单是否填写
      let yanzheng = ['DocDate','DocNo', 'OutClassId', 'InClassId', 'WarehouseId', 'EmpId']
      
      for(let key in this.data){

        if(yanzheng.indexOf(key) !== -1 && (!this.data[key])){
          this.$message({type: 'warning', message: '表单未填写完整'})
          return;
        }
      }


      let Products = this.getProducts(this.tableData);

      Products = Products.concat(this.delTableData);

      Products = Products.filter((item) => {
        return item.T != null && item.ProductId !== 0 && item.ProductId != null;
      });

      // let ProductsLength = Products.length;
      // for(let i = 0; i < ProductsLength; ++i){
      //   if(Products[i].InventoryQuantity === 0){
      //      this.$message({type: 'warning', message: '盘点数量不能为0'})
      //     return
      //   }
      // }
      // Products.forEach(item=>{
      //   if(item.InventoryQuantity===0)
      // })
      let o = {
        Products,
        ...this.data,
      };

      this.api.save(o).then((res) => {
        if (res.Code === 0) {
          if (this.viewType === "create") {
            this.data.DocId = res.Data;
          }
          this.$message({ type: "success", message: res.Msg });
          this.isSave = true;

          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: "warning", message: "请先进行保存再操作" });
        return;
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
        this.getPreviewNo();
        this.$route.params.type = "create";
        this.viewType = "create";
        this.init();
        this.isSave = false;
      }
    },
    reView() {
      let id = this.data.DocId;
      this.api.review(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    cancelReView() {
      let id = this.data.DocId;
      this.api.back(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    handleDelete() {
      let Id = this.data.DocId;
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        this.api.delete({ Id }).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Msg });
            this.newAdd();
            // this.$emit('deleted')
          } else {
            this.$message({ type: "warning", message: res.Msg });
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;

  .text {
    width: 60px;
  }
}

.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}

.span {
  display: inline-block;
  width: 180px;
}
</style>
